import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { ProductManagementPage } from '@/features/products'

export const Route = createFileRoute('/_authenticated/products/')({
  component: () => (
    <RequirePermission permission='products.read'>
      <ProductManagementPage />
    </RequirePermission>
  ),
})
